export default __webpack_public_path__ + "static/media/Total_bet.98307677.svg";